export const getGiveawayBreakdownTypeLabel = (type) => {
    const types = {
        GIFT_REDEEM: 'Redemption',
        GIVEAWAY_PURCHASE: 'Gift purchase',
    };
    return types[type];
};
